import { Modal, ModalHeader, ModalBody } from "reactstrap";
import React, { useState, useEffect } from "react";
import InputComponent from "components/form/Input";
import RadioButton from "components/form/Radio";
import SelectComponent from "components/form/Select";
import { useSelector } from "react-redux";
import Alert from "components/Alert";
import "pages/Pricing/Pricing.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import statusList from "content/radioCommon";
const rolesList = [
    {
        value: "viewer",
        label: "Viewer",
    },
    {
        value: "admin",
        label: "Admin",
    },
    {
        value: "editor",
        label: "Editor",
    },
    {
        value: "user",
        label: "User",
    },
];


function UserModel({ open, toggleModel, data, handleData, onSubmit, errorMessage, setErrorHandle }) {


  


    const { message } = useSelector(state => state.user);
  
    const [resetMessage, setResetMessage] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    useEffect(() => {
        let resetTimer;

        if (message) {

            // Set resetMessage to true when there is a message
            setResetMessage(true);
            // Set a timer to reset resetMessage after 3000 milliseconds (3 seconds)
            resetTimer = setTimeout(() => {
                setResetMessage(false);
            }, 3000);
        }

        // Clear the timer and reset resetMessage on component unmount or when a new message arrives
        return () => {
            clearTimeout(resetTimer);
            setResetMessage(false);
        };
    }, [message]);




    return (
        <>
            {resetMessage && (

                <Alert
                    variant={"success"}
                    key={"success"}
                    showAlert={resetMessage}
                    message={message}
                    className={"slide-in-from-right"}
                    style={{ position: 'fixed', bottom: '0px', right: '3px', width: '35%' }}
                />

            )}

            <Modal isOpen={open} toggle={toggleModel} modalTransition={{ timeout: 300 }}>
                <ModalHeader toggle={toggleModel}>{data.modalType}</ModalHeader>
                <ModalBody>
                    {data.modalType !== "password Update" && (
                        <>
                            <InputComponent
                                type="text"
                                onChange={(e) => {

                                    handleData("firstname", e.target.value)
                                    setErrorHandle("firstName", undefined)
                                }}
                                label={"First Name"}
                                errorMessage={errorMessage.firstName}
                                inputClassName={data.firstname && 'is-valid'}
                                value={data.firstname}
                                className={"h-100 mt-3 "}
                            />
                            <InputComponent
                                onChange={(e) => {
                                    handleData("lastname", e.target.value)
                                    setErrorHandle("lastName", undefined)
                                }}
                                type="text"
                                label={"Last Name"}
                                value={data.lastname}
                                errorMessage={errorMessage.lastName}
                                inputClassName={data.lastname && 'is-valid'}
                                className={"h-100 mt-3"}
                            />
                            <InputComponent
                                type="email"
                                onChange={(e) => {
                                    handleData("email", e.target.value)
                                    setErrorHandle("Email", undefined)
                                }}
                                label={"Email"}
                                errorMessage={errorMessage.Email}
                                placeholder="example@xyz.com"
                                inputClassName={data.email && 'is-valid'}
                                value={data.email}
                                className={"h-100 mt-3"}
                            />
                        </>
                    )}

                    {(data.modalType === "Register New User" || data.modalType === "password Update") && (
                        <div style={{ position: 'relative', width: '100%' }}>

                            <InputComponent
                                type={showPassword ? 'text' : 'password'}
                                onChange={(e) => {
                                    handleData("password", e.target.value)
                                }}
                                label={"Password"}
                                required
                                placeholder="Should be alphanumeric & atleast one symbol"
                                value={data.password}
                                className={`h-100 mt-3 `}
                                style={{ width: 'calc(100% - 30px)' }}
                            />
                            <FontAwesomeIcon
                                icon={showPassword ? faEyeSlash : faEye}
                                onClick={togglePasswordVisibility}
                                style={{
                                    position: 'absolute',
                                    right: '30px', // Adjust right position as needed
                                    top: '71%',
                                    transform: 'translateY(-50%)',
                                    cursor: 'pointer',
                                    color: showPassword ? '#ff0000' : '#000',
                                }}
                            />
                        </div>
                    )}

                    {data.modalType !== "password Update" && (
                        <>
                            <SelectComponent
                                label={"Role"}
                                onChange={(e) => {
                                    handleData("role", e.target.value)
                                    setErrorHandle("role", undefined)
                                }}
                                errorMessage={errorMessage.role}
                                optionList={rolesList}
                                inputClassName={data.role && 'is-valid'}
                                value={data.role}
                                className="mb-1  mt-0"
                                firstOption={"Please select Role"}
                            />

                            <InputComponent
                                label={"EIS Id"}
                                onChange={(e) => {
                                    handleData("eisId", e.target.value)
                                    setErrorHandle("EISId", undefined)
                                }}
                                value={data.eisId}
                                errorMessage={errorMessage.EISId}
                                inputClassName={data.eisId && 'is-valid'}
                                className={"h-100 mt-3"}
                            />

                            <InputComponent
                                label={"Subarea Id"}
                                onChange={(e) => {
                                     
                                    handleData("subareaId", Number(e.target.value))
                                    setErrorHandle("SubareaId", undefined)
                                }}
                                value={data.subareaId}
                                errorMessage={errorMessage.subareaId}
                                inputClassName={data.subareaId && 'is-valid'}
                                
                                className={"h-100 mt-3"}
                            />

                            <RadioButton
                                elementStyle={{ cursor: "pointer" }}
                                label={"Status"}
                                radioBtnList={statusList}
                                className={"w-100 mt-3"}

                                value={data.status}
                                handleRadioChange={(e) => handleData("status", e.target.value)}
                            />
                        </>
                    )}
                    <div className="d-flex">
                        <button onClick={toggleModel} className="btn btn-light  my-3 w-100">
                            Cancel
                        </button>
                        <button type="submit" className="btn btn-dark  my-3 w-100" onClick={onSubmit}>
                            Submit
                        </button>
                    </div>
                </ModalBody>
            </Modal>

        </>
    );
}

export default UserModel;
